export default __webpack_public_path__ + "static/media/10_of_hearts.bf72f319.png";